import React from 'react';
import { Form, Input } from 'antd';

const TemplateInfo = ({ form, disabled, validateField }) => {
  const { getFieldDecorator } = form;
  const validateName = validateField('name');
  return (
    <React.Fragment>
      <div className="offer-card__item">
        <span className="label">Наименование шаблона:</span>
        <Form.Item
          help={validateName.help}
          validateStatus={validateName.status}
        >
          {getFieldDecorator('name', {
            rules: [
              {
                required: true,
                message: 'Поле, обязательное для заполнения',
              },
            ],
          })(<Input style={{ width: 368 }} disabled={disabled} />)}
        </Form.Item>
      </div>

      {/*
      <div className="offer-card__item">
        <span className="label">Вид транспортной услуги:</span>
        {getFieldDecorator('serviceType')(
          <Input style={{ width: 368 }} disabled={disabled} />
        )}
      </div>
      <div className="offer-card__item">
        <span className="label">Количество пассажиров:</span>
        {getFieldDecorator('passengersCount')(
          <Input style={{ width: 80 }} disabled={disabled} />
        )}
      </div>
       */}
    </React.Fragment>
  );
};

export default TemplateInfo;
